// Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.

export { default } from './index';
